const SET_MEMBER_HISTORICAL_DOCUMENTS = 'SET_MEMBER_HISTORICAL_DOCUMENTS';
const RESET_MEMBER_HISTORICAL_DOCUMENTS = 'RESET_MEMBER_HISTORICAL_DOCUMENTS';

export const MEMBER_HISTORICAL_DOCUMENTS_ACTION_TYPES = {
    SET_MEMBER_HISTORICAL_DOCUMENTS,
    RESET_MEMBER_HISTORICAL_DOCUMENTS,
};
